<template>
  <html id="printableArea" style="width:100%;overflow-y:visible;padding-left:4px;padding-right:4px">
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
      <title>Печать отчета</title>
    </head>
    <body class="printableArea">
      <div class="rheader">
        <div class="rtitle">
          <div style="line-height: 34px" class="rcaption">
            <h2>Т А Б Е Л Ь</h2>
            <h3>УЧЕТА ПОСЕЩАЕМОСТИ ДЕТЕЙ</h3>
            <h3>за {{formattedMonth}} </h3>
          </div>
          <div class="field whfield">Учреждение</div>
          <div class="field whfield">Структурное подразделение</div>
          <div class="field whfield">Вид расчета</div>
          <div class="field whfield">Режим работы</div>
        </div>
        <div class="head_table">
          <div class="ht1">Коды</div>
          <div class="ht2">
            <div class="ht21">Форма по ОКУД</div>
            <div class="ht22">0504608</div>
          </div>
          <div class="ht2">
            <div class="ht21">Дата</div>
            <div class="ht22">{{today}}</div>
          </div>
          <div class="ht2">
            <div class="ht21">По ОКПО</div>
            <div class="ht22">&nbsp;</div>
          </div>
          <div class="ht2">
            <div class="ht21">&nbsp;</div>
            <div class="ht22">&nbsp;</div>
          </div>
          <div class="ht2">
            <div class="ht21">&nbsp;</div>
            <div class="ht22">&nbsp;</div>
          </div>
          <div class="ht2">
            <div class="ht21">&nbsp;</div>
            <div class="ht22">&nbsp;</div>
          </div>
        </div>
      </div>
      <br><br>
      <div>
        <table
          v-for="tabnum in parseInt(Math.ceil(entries.length / 25))"
          :key="tabnum"
          border="1"
          cellpadding="0"
          cellspacing="0"
          style="font-size:10pt;border-collapse:collapse;"
          class="mt-4 entry"
        >
          <th :colspan="`${daysInMonth + 8}`" style="text-align:right;border:none" class="pr-2">
            <span v-if="saletype">{{saletype.title}} ({{tag}})</span> стр. {{tabnum}}/{{parseInt(Math.ceil(entries.length / 25))}}
          </th>
          <tr style="height:20px">
            <th colspan="2" rowspan="2" class="fio_rheader">Фамилия, имя ребенка</th>
            <th rowspan="2" class="c1">Номер счета</th>
            <th rowspan="2" class="c1">Плата по ставке</th>
            <th :colspan="daysInMonth" class="days_head days_h">Дни посещения</th>
            <th colspan="2" class="c21">Пропущено дней</th>
            <th rowspan="2" class="c3">Дни посещения подлежащие оплате</th>
            <th rowspan="2" class="c4">Причины непосещения</th>
          </tr>
          <tr style="height:20px">
            <th v-for="i in daysInMonth" :key="i" class="days">{{i}}</th>
            <th class="c22">Всего</th>
            <th class="c23">В том числе засчитываемых</th>
          </tr>
          <tr
            v-if="entries &&
            entries.length > 0 &&
            (i <= 25 && tabnum <= entries.length / 25) || (entries.length < 25) || (i <= 25 && i <= entries.length % ((tabnum - 1) * 25))"
            v-for="i in entries.length"
            :key="i"
            style="height:23px"
          >
            <td class="half_field">{{(tabnum - 1) * 25 + i}}</td>
            <td class="fio">{{entries[(tabnum - 1) * 25 + i - 1].fullname}}</td>
            <td class="some_field">{{entries[(tabnum - 1) * 25 + i - 1].positionname}}</td>
            <td class="some_field"></td>
            <td v-for="day in daysInMonth" :key="day" class="day_checks">
              <small>{{days(entries[(tabnum - 1) * 25 + i - 1])[day - 1]}}</small>
            </td>
            <td class="some_field"><span>{{skipped(entries[(tabnum - 1) * 25 + i - 1])}}</span></td>
            <td class="some_field"></td>
            <td class="some_field"><span>{{entries[(tabnum - 1) * 25 + i - 1].days.length}}</span></td>
            <td class="some_longer_field"></td>
          </tr>
          <!-- итого -->
          <tr v-if="tabnum === parseInt(Math.ceil(entries.length / 25))" style="height:23px">
            <td class="half_field"></td>
            <td class="fio"><strong>Всего отсутствует детей</strong></td>
            <td class="some_field"></td>
            <td class="some_field"></td>
            <td v-for="(day, i) in daysInMonth" :key="day" class="day_checks">
              <small v-if="sums[i] > 0">{{ entries.length - sums[i] }}</small>
              <small v-else>В</small>
            </td>
            <td class="some_field">
              <span>{{ entries.length * totaldays - total }} / {{ entries.length * totaldays }}</span>
            </td>
            <td class="some_field"></td>
            <td class="some_field"><span>{{ total }}</span></td>
            <td class="some_longer_field"></td>
          </tr>
          <tr v-if="tabnum === parseInt(Math.ceil(entries.length / 25))" style="height:23px">
            <td class="half_field"></td>
            <td class="fio"><strong>Всего присутствует детей</strong></td>
            <td class="some_field"></td>
            <td class="some_field"></td>
            <td v-for="(day, i) in daysInMonth" :key="day" class="day_checks">
              <small v-if="sums[i] > 0">{{ sums[i] }}</small>
              <small v-else>В</small>
            </td>
            <td class="some_field"></td>
            <td class="some_field"></td>
            <td class="some_field"></td>
            <td class="some_longer_field"></td>
          </tr>
        </table>
        <br><br>
      </div>
      <div style="padding-top:40px">
        <table width="1300px">
          <tr height="40px">
            <td style="padding-right:10px;padding-left:10px;">
              <hr><small>(должность)</small>
            </td>
            <td style="padding-right:10px;padding-left:10px;">
              <hr><small>(подпись)</small>
            </td>
            <td style="padding-right:10px;padding-left:10px;">
              <hr><small>(расшифровка подписи)</small>
            </td>
          </tr>
          <tr height="40px">
            <td style="padding-right:10px;padding-left:10px;">
              <hr><small>(должность)</small>
            </td>
            <td style="padding-right:10px;padding-left:10px;">
              <hr><small>(подпись)</small>
            </td>
            <td style="padding-right:10px;padding-left:10px;">
              <hr><small>(расшифровка подписи)</small>
            </td>
            <td style="padding-right:10px;padding-left:10px;vertical-align:top">
              <center><small>{{today}}</small></center>
            </td>
          </tr>
        </table>
      </div>
      <br>
      <small v-if="report">Дата составления: {{ reportDate }}</small>
    </body>
  </html>
</template>

<script>
import moment from 'moment'
import '@babel/polyfill'
import firstBy from 'thenby'
import ExcelJS from 'exceljs'

function flatten (arr) {
  return arr.reduce(function (a, b) {
    return a.concat(Array.isArray(b) ? flatten(b) : b)
  }, [])
}

export default {
  name: 'AttendanceReport',
  props: [ 'data', 'month', 'saletype', 'tag' ],
  data: () => ({
    today: moment().format('DD.MM.YYYY') + ' г.',
    report: null,
    entries: [],
    pages: [],
    sums: [],
  }),
  computed: {
    monthName () {
      moment.locale('ru')
      return moment.months()[parseInt(this.month.split('-')[1]) - 1]
    },
    daysInMonth () {
      return moment(this.month).daysInMonth()
    },
    personsCount () {
      return this.data.length
    },
    total () {
      return this.sums.reduce((r, x) => r + x, 0)
    },
    totaldays () {
      return this.sums.filter(x => !!x).length
    },
    formattedMonth () {
      return moment(this.month).format('MMMM YYYY') + ' г.'
    },
    reportDate () {
      return moment().format('DD.MM.YYYY')
    },
  },
  methods: {
    days (entry) {
      const days = []
      for (let d = 1; d <= this.daysInMonth; d++) {
        let mark
        if (d > this.daysInMonth) {
          mark = '-'
        } else if (this.sums[d - 1] === 0) {
          mark = 'В'
        } else if (entry.days.includes(`${this.month}-${d.toString().padStart(2, '0')}`)) {
          mark = ' '
        } else {
          mark = 'Н'
        }
        days.push(mark)
      }
      return days
    },
    skipped (entry) {
      return this.days(entry).reduce((r, x) => r + (x === 'Н' ? 1 : 0), 0)
    },
    addExcelSigns (sheet) {
      const signRow = sheet.addRow([])
      let col = 1
      col = this.mergeCellsByWidth(sheet, signRow.number, 50, col)
      sheet.getCell(signRow.number, 1).value = '(Должность)'
      sheet.getCell(signRow.number, 1).border = { top: { style: 'thin' } }
      sheet.getCell(signRow.number, 1).font = { size: 7 }
      sheet.getCell(signRow.number, 1).alignment = { vertical: 'top', horizontal: 'left' }

      col += 3
      col = this.mergeCellsByWidth(sheet, signRow.number, 150, col)
      sheet.getCell(signRow.number, col).value = '(Подпись)'
      sheet.getCell(signRow.number, col).border = { top: { style: 'thin' } }
      sheet.getCell(signRow.number, col).font = { size: 7 }
      sheet.getCell(signRow.number, col).alignment = { vertical: 'top', horizontal: 'left' }

      col += 3
      col = this.mergeCellsByWidth(sheet, signRow.number, 150, col)
      sheet.getCell(signRow.number, col).value = '(Расшифровка подписи)'
      sheet.getCell(signRow.number, col).border = { top: { style: 'thin' } }
      sheet.getCell(signRow.number, col).font = { size: 7 }
      sheet.getCell(signRow.number, col).alignment = { vertical: 'top', horizontal: 'left' }
    },
    mergeCellsByWidth (worksheet, rowNumber, targetWidth, startCol = 1) {
      let currentWidth = 0
      let endCol = startCol

      for (let i = startCol; i <= worksheet.columns.length; i++) {
        const colWidth = worksheet.getColumn(i).width || 8.43
        currentWidth += colWidth
        endCol = i
        if (currentWidth >= targetWidth) break
      }
      worksheet.mergeCells(rowNumber, startCol, rowNumber, endCol)
      return endCol
    },
    async makeXLSX () {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Табель')

      const totalColumns = 4 + this.daysInMonth + 4
      const leftColumnsStart = 5
      const rightStartColumn = totalColumns - 2
      const rightEndColumn = totalColumns - 1
      const lastColumn = totalColumns

      const t1 = sheet.addRow(['Т А Б Е Л Ь'])
      sheet.mergeCells(t1.number, 1, t1.number, totalColumns - 3)
      t1.font = { bold: true, size: 16 }
      t1.alignment = { horizontal: 'center' }

      const t2 = sheet.addRow(['УЧЕТА ПОСЕЩАЕМОСТИ ДЕТЕЙ'])
      sheet.mergeCells(t2.number, 1, t2.number, totalColumns - 3)
      t2.font = { bold: true, size: 14 }
      t2.alignment = { horizontal: 'center' }

      const t3 = sheet.addRow([`за ${this.formattedMonth}`])
      sheet.mergeCells(t3.number, 1, t3.number, totalColumns - 3)
      t3.font = { italic: true, size: 12 }
      t3.alignment = { horizontal: 'center' }

      const headerRow = sheet.addRow([])
      sheet.mergeCells(headerRow.number, totalColumns - 2, headerRow.number, totalColumns)
      const headerCell = headerRow.getCell(totalColumns - 2)
      headerCell.value = 'Коды'
      headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      headerCell.font = { bold: true, size: 14 }

      sheet.mergeCells(headerRow.number, 1, headerRow.number, leftColumnsStart + this.daysInMonth - 1)

      sheet.addRow([])

      const leftHeaderRows = ['Учреждение', 'Структурное подразделение', 'Вид расчета', 'Режим работы']
      const rightHeaderRows = ['Форма по ОКУД', 'Дата', 'По ОКПО']
      leftHeaderRows.forEach((text) => {
        const row = sheet.addRow([])
        sheet.mergeCells(row.number, leftColumnsStart, row.number, leftColumnsStart + 9)
        sheet.mergeCells(row.number, leftColumnsStart + 10, row.number, leftColumnsStart + this.daysInMonth - 1)
        const leftCell = row.getCell(leftColumnsStart)
        leftCell.value = text
        leftCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
        leftCell.font = { bold: true }
        leftCell.border = { bottom: { style: 'thin' } }
        leftCell.protection = { locked: true }

        const rightCell = row.getCell(leftColumnsStart + 10)
        rightCell.protection = { locked: false }
        rightCell.border = { bottom: { style: 'thin' } }

        const rightText = rightHeaderRows.shift()
        if (rightText !== undefined) {
          if (rightText === 'Форма по ОКУД') {
            sheet.mergeCells(row.number, rightStartColumn, row.number, rightEndColumn)
            const rightCell = row.getCell(rightStartColumn)
            rightCell.value = rightText
            rightCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
            rightCell.font = { bold: true }
            rightCell.protection = { locked: true }

            const valueCell = row.getCell(lastColumn)
            valueCell.value = '0504608'
            valueCell.alignment = { vertical: 'middle', horizontal: 'center' }
            valueCell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            valueCell.protection = { locked: false }
          } else if (rightText === 'Дата') {
            sheet.mergeCells(row.number, rightStartColumn, row.number, rightEndColumn)
            const rightCell = row.getCell(rightStartColumn)
            rightCell.value = rightText
            rightCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
            rightCell.font = { bold: true }
            rightCell.protection = { locked: true }

            const dateCell = row.getCell(lastColumn)
            dateCell.value = `${moment().format('DD.MM.YYYY')} г.`
            dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
            dateCell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            dateCell.protection = { locked: false }
          } else {
            sheet.mergeCells(row.number, rightStartColumn, row.number, rightEndColumn)
            const rightCell = row.getCell(rightStartColumn)
            rightCell.value = rightText
            rightCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
            rightCell.font = { bold: true }
            rightCell.protection = { locked: true }

            const lastCell = row.getCell(lastColumn)
            lastCell.value = ''
            lastCell.alignment = { vertical: 'middle', horizontal: 'center' }
            lastCell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            lastCell.protection = { locked: false }
          }
        }
      })

      sheet.addRow([])

      const complexNameHeader = sheet.addRow([])
      sheet.mergeCells(complexNameHeader.number, 1, complexNameHeader.number, this.daysInMonth + 8)
      const cell = complexNameHeader.getCell(1)
      cell.value = `${this.saletype.title} ${this.tag ? `(${this.tag})` : ''}`
      cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true }
      cell.font = { bold: true }
      cell.protection = { locked: true }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

      const headerRow1 = sheet.addRow([
        '№', 'Фамилия, имя ребёнка', 'Номер счета', 'Плата по ставке',
        ...Array.from({ length: this.daysInMonth }, () => 'Дни посещения'),
        'Пропущено дней', 'Пропущено дней (засчитываемых)',
        'Дни посещения (оплата)', 'Причины непосещения'
      ])

      const headerRow2 = sheet.addRow([
        '', '', '', '',
        ...Array.from({ length: this.daysInMonth }, (_, i) => `${i + 1}`),
        'Всего', 'В том числе засчитываемых', '', ''
      ])
      for (const row of [headerRow1, headerRow2]) {
        try {
          row.font = { bold: true, size: 10 }
          row.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
          row.height = 40
          row.eachCell(cell => {
            cell.border = {
              top: {
                style: 'thin'
              },
              left: {
                style: 'thin'
              },
              bottom: {
                style: 'thin'
              },
              right: {
                style: 'thin'
              }
            }
            cell.protection = { locked: true }
          })
        } catch (error) {
          console.error(error)
        }
      }

      sheet.mergeCells(headerRow1.number, 5, headerRow1.number, 4 + this.daysInMonth)
      sheet.mergeCells(headerRow1.number, 5 + this.daysInMonth, headerRow1.number, 6 + this.daysInMonth)
      sheet.mergeCells(headerRow1.number, 7 + this.daysInMonth, headerRow2.number, 7 + this.daysInMonth)
      sheet.mergeCells(headerRow1.number, 8 + this.daysInMonth, headerRow2.number, 8 + this.daysInMonth)

      await sheet.protect('123456', {
        selectLockedCells: true,
        selectUnlockedCells: true,
      })

      sheet.pageSetup = {
        orientation: 'landscape',
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
        margins: { left: 0.3, right: 0.3, top: 0.5, bottom: 0.5, header: 0.2, footer: 0.2 },
        printTitlesRow: `${complexNameHeader.number}:${headerRow2.number}`,
        headerFooter: {
          differentFirst: false,
          oddHeader: '&CТабель посещаемости',
          oddFooter: '&LДата: &D &T&CСтраница &P из &N&R'
        }
      }

      this.entries.forEach((entry, idx) => {
        const rowData = [
          idx + 1,
          entry.fullname,
          entry.positionname,
          '',
          ...this.days(entry),
          this.skipped(entry),
          '',
          entry.days.length,
          ''
        ]
        const r = sheet.addRow(rowData)
        r.eachCell((cell, colNumber) => {
          cell.alignment = { vertical: 'middle', horizontal: colNumber === 2 ? 'left' : 'center' }
          cell.border = {
            top: {
              style: 'thin'
            },
            left: {
              style: 'thin'
            },
            bottom: {
              style: 'thin'
            },
            right: {
              style: 'thin'
            }
          }
          cell.protection = { locked: colNumber !== rowData.length }
        })
      })

      for (let dayIndex = 0; dayIndex < this.daysInMonth; dayIndex++) {
        const colNumber = 5 + dayIndex
        let absentCount = 0
        sheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber > headerRow2.number) {
            const cell = row.getCell(colNumber)
            if (!cell.value) absentCount++
          }
        })
        sheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber > headerRow2.number) {
            const cell = row.getCell(colNumber)
            if (!cell.value) {
              cell.value = absentCount === this.entries.length ? 'В' : 'Н'
            }
          }
        })
      }

      const absentRow = sheet.addRow([
        '', 'Всего отсутствует детей', '', '',
        ...this.sums.map(s => this.entries.length - s),
        `${this.entries.length * this.totaldays - this.total} / ${this.entries.length * this.totaldays}`,
        '', this.total, ''
      ])

      const presentRow = sheet.addRow(['', 'Всего присутствует детей', '', '', ...this.sums, '', '', '', ''])

      for (const row of [absentRow, presentRow]) {
        row.font = { bold: true }
        row.eachCell(cell => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
          cell.font = { bold: true, size: 10 }
          cell.alignment = { vertical: 'middle', horizontal: 'center' }
          cell.protection = { locked: true }
        })
      }
      sheet.addRow([])
      sheet.addRow([])
      sheet.addRow([])
      this.addExcelSigns(sheet)
      sheet.addRow([])
      sheet.addRow([])
      this.addExcelSigns(sheet)
      sheet.addRow([])
      const dateRow = sheet.addRow([])
      sheet.mergeCells(dateRow.number, 1, dateRow.number, sheet.columns.length)
      sheet.getCell(dateRow.number, 1).value = `Дата составления: ${this.today}`

      sheet.columns.forEach((col, index) => {
        if (index === 1) {
          let maxLength = 0
          col.eachCell({ includeEmpty: true }, cell => {
            const value = cell.value ? cell.value.toString() : ''
            maxLength = Math.max(maxLength, value.length)
          })
          col.width = maxLength + 2
        } else if ((index >= 4 && index < 4 + this.daysInMonth) || index === 0) {
          col.width = 4
        } else if ([2, 3].includes(index)) {
          col.width = 8
        } else {
          col.width = 12
        }
      })

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'tabel.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    }
  },
  mounted () {
    this.report = this.data
    this.entries = this.report
      .map(x => {
        x.positionname = x.positionname ? x.positionname : x.person ? x.person.positionname : ''
        x.positionindex = parseInt(x.positionname)
        x.fullname = x.person ? x.person.fullname : ''
        return x
      })
      .sort(
        firstBy('positionindex')
          .thenBy('positionname', { ignoreCase: true })
          .thenBy('fullname')
      )
    let reduced = this.entries
      .map(x => x.days)
    reduced = flatten(reduced)
      .reduce((r, x) => {
        if (r[x]) {
          r[x]++
        } else {
          r[x] = 1
        }
        return r
      }, {})
    const sums = []
    for (let d = 1; d <= this.daysInMonth; d++) {
      sums.push(
        reduced[`${this.month}-${d.toString().padStart(2, '0')}`] || 0
      )
    }
    this.sums = sums
  },
}
</script>

<style lang="css" scoped>
</style>
